<div class="task-package-summary-item" [class.editing]="isEditing" (click)="onItemClick()">
  <app-project-config-node
    [itemNumber]="itemNumber"
    [value]="taskPackage.name"
    [placeholder]="'Task Package Name'"
    [isEditing]="isEditing"
    [(selected)]="isSelected"
    [allowEdit]="allowEdit"
    [allowDelete]="true"
    [isArchived]="isArchived"
    [allowArchive]="false"
    [color]="'var(--color-task-package)'"
    [validationCallback]="validationCallback"
    [displayTemplate]="displayTemplate"
    [editTemplate]="editTemplate"
    (onSave)="handleSave()"
    (onCancel)="onCancel.emit()"
    (onDelete)="onDelete.emit()"
    (onStartEdit)="onEditing()"
    (onArchive)="onArchive.emit()"
    (onReactivate)="onReactivate.emit()"
    (hovering)="hovering.emit($event)"
  >
    <!-- Display Template -->
    <ng-template #displayTemplate>
      <div class="task-package-display">
        <span>{{ itemNumber }}.</span>
        <span class="task-package-name">{{ taskPackage.name }}</span>
      </div>
    </ng-template>

    <!-- Edit Template -->
    <ng-template #editTemplate>
      <div class="task-package-edit-container">
        <div class="edit-form">
          <div class="name-field">
            <dx-text-box
              [(value)]="editData.name"
              i18n-placeholder="@@name"
              placeholder="Name"
              valueChangeEvent="input"
              class="gpd-input"
              validationMessageMode="always"
              [maxLength]="100"
            >
              <dx-validator>
                <dxi-validation-rule type="required" i18n-message="@@nameRequired" message="Name is required" />
                <dxi-validation-rule
                  type="custom"
                  [reevaluate]="true"
                  [validationCallback]="uniqueNameValidationCallback"
                  i18n-message="@@nameAlreadyExists"
                  message="Name already Exists"
                />
              </dx-validator>
            </dx-text-box>
          </div>
        </div>
      </div>
    </ng-template>
  </app-project-config-node>
</div>
